import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';

import { loadProductsByTag } from '../../../redux/modules/products';
import { getTagName } from '../../../redux/modules/tags';

import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import A from '../../shared/Anchor/Anchor';
import { primary_dark15, primary_light } from '../../shared/lib/colors';

import '../Categoria/Categoria.scss';
import IubendaCookieSolution from '../../../utils/iubenda';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { getSHA256Hash } from '../../../utils/sha256';
import { criteoViewList } from '../../shared/lib/criteo';
import { gtmToGa4ViewItemList } from '../../shared/lib/gtmEnhancedEcommerce.js';
import { cleanImage } from '../../../utils/images.js';

class Tag extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    if (this.props.hasCriteo) {
      // const iubenda = new IubendaCookieSolution(
      //   this.props.hasIubendaCookieSolution
      // );
      // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      this.renderCriteoTag();
    }

    // TRACK LIST - GTM, GA4, FKMX
    if (
      [
        this.props.hasGoogleTagManager,
        this.props.hasGoogleAnalytics4Advanced,
        this.props.hasFarmakomMetrics,
      ].some(t => !!t)
    ) {
      this.trackItemsList();
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      if (this.props.hasCriteo) {
        // const iubenda = new IubendaCookieSolution(
        //   this.props.hasIubendaCookieSolution
        // );
        // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        this.renderCriteoTag();
      }

      // TRACK LIST - GTM, GA4, FKMX
      if (
        [
          this.props.hasGoogleTagManager,
          this.props.hasGoogleAnalytics4Advanced,
          this.props.hasFarmakomMetrics,
        ].some(t => !!t)
      ) {
        this.trackItemsList();
      }
    }
  }

  trackItemsList = () => {
    const { products } = this.props;
    const { tag } = this.props.params;

    const ga4ListInfo = {
      id: `tag_${tag}`,
      name: `tag > ${tag}`,
    };

    if (this.props.hasGoogleTagManager) {
      gtmToGa4ViewItemList(products, ga4ListInfo);
    }
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4ViewItemList(products, ga4ListInfo);
    }
    if (this.props.hasFarmakomMetrics) {
      fkmxViewItemList(products, ga4ListInfo);
    }
  };

  renderCriteoTag = async () => {
    // <!-- Criteo Category / Search / Listing Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';

    criteoViewList(
      this.props.criteoAccountId,
      {
        email,
        zipcode,
      },
      this.props.products
    );
    // <!-- END Criteo Category / Search / Listing Tag -->
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts() {
    const { isMobile } = this.props;
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const { tag } = this.props.params;
    const ga4ListInfo = {
      id: `tag_${tag}`,
      name: `tag > ${tag}`,
    };

    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div className="col-sm-6 col-lg-4" key={product.id}>
              <ProductThumbnail
                product={product}
                list="tag"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const { tag } = this.props.params;
    const ga4ListInfo = {
      id: `tag_${tag}`,
      name: `tag > ${tag}`,
    };

    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="tag"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const { tag } = this.props.params;
    const {
      location,
      pagination,
      products,
      tagName,
      loading,
      siteName,
      logoImage,
      primaryColor,
      uiVariantButton,
    } = this.props;

    const capitalizeFirst = string =>
      string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`${tag} online`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita ${tag}`,
            },
            {
              name: 'keywords',
              content: `${tag}, ecommerce, farmacia, ${siteName}`,
            },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita ${tag}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online ${tag}`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          <LeftFilters
            tag={tag}
            location={location}
            sort={location.query.sort || 'sales'}
          />

          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb page="tag" tag={tag} />

              {products.length > 0 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
                borderRadius:
                  uiVariantButton === '1'
                    ? '12px'
                    : uiVariantButton === '3'
                    ? '30px'
                    : 0,
              }}
            >
              {capitalizeFirst(tagName)}
              {loading && (
                <span className="pull-right">
                  <FaSpinner className="pulse" />
                </span>
              )}
            </div>

            {!loading && products.length > 0 && (
              <div>
                <div className="row">{this.renderProducts()}</div>

                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  primaryColor={primaryColor}
                  isNew
                  uiVariantButton={uiVariantButton}
                />
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto trovato per questo tag.</p>
                <p>Prova a ricercare per parole chiave.</p>
              </div>
            )}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    pagination: state.products.pagination,
    products: state.products.data,
    loading: state.products.loading,
    tagName: getTagName(state, ownProps.params.tag),
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasCriteo: state.store.data.features.hasCriteo,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Tag, [loadProductsByTag])
);
